import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { WizardStep } from '../../../shared/controls/wizard-control/wizard-step.interface';
import { WizardStepComponent } from '../../../shared/controls/wizard-control/wizard-step.component';
import { WizardControlComponent } from '../../../shared/controls/wizard-control/wizard-control.component';

import { PremiumDataService } from '../../../../service/proxy';
import { PremiumDataRowSelectionComponent } from './steps/range-mapping/premium-data-row-selection.component';
import { PremiumDataColumnSelectionComponent } from './steps/column-mapping/premium-data-column-selection.component';
import { PremiumImportDataComponent } from './steps/import-data/premium-import-data.component';
import { ErrorService } from '../../../shared/services/error-service';

import { ToastService } from '../../../shared/toast/toast.service';

@Component({
    selector: 'premium-data-wizard',
    templateUrl: './premium-data-wizard.component.html',
    styleUrl: './premium-data-wizard.component.scss',

    imports: [
        CommonModule,
        FormsModule,

        WizardControlComponent,
        WizardStepComponent,

        PremiumDataRowSelectionComponent,
        PremiumDataColumnSelectionComponent,
        PremiumImportDataComponent
    ],

    providers: [
        PremiumDataService
    ]
})
export class PremiumDataWizardComponent implements OnInit, AfterViewInit {
    @ViewChild('rowSelectionComponent')
    rowSelectionComponent!: WizardStep;

    @ViewChild('columnSelectionComponent')
    columnSelectionComponent!: WizardStep;

    @ViewChild('importComponent')
    importComponent!: WizardStep;

    public batchId: number = 0;
    public viewInitialized: boolean = false;

    constructor (
        private route: ActivatedRoute,
        private router: Router,
        private premiumDataService: PremiumDataService,
        private errorService: ErrorService,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.batchId = +params['id'];
        });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.viewInitialized = true;
            this.cdr.detectChanges();
        });
    }

    isRowSelectionValid(): boolean {
        if (!this.viewInitialized) return true;
        return this.rowSelectionComponent?.isValid() || false;
    }

    isColumnSelectionValid(): boolean {
        if (!this.viewInitialized) return true;
        return this.columnSelectionComponent?.isValid() || false;
    }

    isImportValid(): boolean {
        if (!this.viewInitialized) return true;
        return this.importComponent?.isValid() || false;
    }

    finished(): void {
        this.premiumDataService.completePremiumDataBatch(this.batchId)
            .subscribe({
                next: () => {
                    this.toastService.show('Premium Data batch completed successfully.', 'Success');
                    this.router.navigate([`/premium-data`]);
                },
                error: (error: any) => {
                    this.errorService.handleError(error);
                }
            }
        );
    }

    onCancel(): void {
        this.router.navigate([`/premium-data`]);
    }
}
